// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "8e90912bbf525063","396": "586e5388bd064faa","460": "90b9677c4cb07c97","917": "1f5c89b4443cef6e","985": "fa4731296443610d",}[chunkId] + ".chunk.js"
}